import React from 'react';
import {
  Box,
  HStack,
  Icon,
  IconButton,
  StackDivider,
  Text,
} from '@wegroup/design-system';
import { InsurancePolicyPackage } from '../../../../../../types/AdvisoryReport';
import PackageActions from './PackageActions';
import useAdvisoryReportCreationParams from '../../../../hooks/useCreationFlowSubject';

interface Props {
  data: InsurancePolicyPackage;
  isOpen: boolean;
  controlled?: boolean;
  onToggle: () => void;
  withActions?: boolean;

  // Actions
  onEdit?: (policyPackage: InsurancePolicyPackage) => void;
  onRemove?: (packageId: string) => void;
}

const InsurancePolicyPackageItemHeader: React.FC<Props> = ({
  data,
  onToggle,
  isOpen,
  controlled,
  withActions = true,
  onEdit,
  onRemove,
}) => {
  const { reportId } = useAdvisoryReportCreationParams();

  return (
    <HStack pt="4" pb="2" justify="space-between">
      <Text textStyle="largeBodyMedium">{data.name}</Text>
      <HStack
        spacing="2"
        divider={<StackDivider borderLeft="1px" borderColor="gray.50" />}
      >
        {withActions && (
          <PackageActions
            reportId={reportId}
            data={data}
            controlled={controlled}
            onEdit={onEdit}
            onRemove={() => onRemove?.(data.id!)}
          />
        )}
        <IconButton
          size="sm"
          variant="grayed"
          onClick={onToggle}
          aria-label="Open insurance policy"
          icon={
            <Box
              transform={isOpen ? 'rotate(180deg)' : undefined}
              transition="0.2s"
            >
              <Icon name="GeneralActionsChevronDown" color="gray.300" />
            </Box>
          }
        />
      </HStack>
    </HStack>
  );
};

export default InsurancePolicyPackageItemHeader;
